import type { TrapetsMode, TrapetsSettingsResponse } from "@repo/shared/types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import * as trapetsApi from "@/lib/api/trapets";

export function useTrapetsSettings() {
  const { data, error, isLoading } = useQuery({
    queryKey: ["trapets-settings"],
    queryFn: () => trapetsApi.getSettings(),
  });
  const queryClient = useQueryClient();
  const mutate = () => queryClient.invalidateQueries({ queryKey: ["trapets-settings"] });
  return {
    settings: data ?? null,
    error,
    isLoading,
    mutate,
  };
}

/**
 * Read-only access to the tenant's Trapets mode for surfaces outside the settings page
 * (flow editor add-component gating, compliance batch lookup). The GET /internal/trapets
 * endpoint is session-gated only, so any authenticated user can resolve the mode.
 */
export function useTrapetsMode(): { trapetsMode: TrapetsMode | null; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ["trapets-settings"],
    queryFn: () => trapetsApi.getSettings(),
    select: (d) => d.trapetsMode,
  });
  return { trapetsMode: data ?? null, isLoading };
}

export type { TrapetsSettingsResponse };
